import React from 'react';
import ReactDOM from 'react-dom';

import FacebookProvider, { Page, Feed } from 'react-facebook';

import Screen from '../../Shared/Helpers/Screen';
import './Facebook.scss';

export default class Facebook extends React.Component {
    constructor(props) {
        super(props);

        this.container = document.getElementsByClassName('component-container')[0];

        this.state = {
            width: this.getElementWidth()
        };

        let resizeAction = null;
        
        window.addEventListener('resize', (e) => {
            const RESIZE_FINISH_TIME = 500;

            clearTimeout(resizeAction);

            resizeAction = setTimeout(() => {
                let componentWidth = this.getElementWidth();

                if (this.state.width != componentWidth) {
                    this.setState({
                        width: componentWidth
                    });
                }
            }, RESIZE_FINISH_TIME);
        });
    }

    getElementWidth() {
        let containerWidth = this.container.getBoundingClientRect().width;

        let modifier = 3;

        if (Screen.isMobile) {
            modifier = 1;
        }

        return Math.floor(containerWidth / modifier);
    }

    render() {
        let height = 600;

        if (Screen.isMobile) {
            height = 568;
        }

        return (
            <FacebookProvider appId="...">
                <Page href={this.props.facebookUrl} height={height} width={this.state.width} smallHeader={this.state.width < 768} />
            </FacebookProvider>);
    }
}

[...document.getElementsByClassName('js-facebook-plugin')].forEach((elem) => {
    let columnsAmount = +elem.dataset.columnsAmount;
    let facebookUrl = elem.dataset.facebookUrl;

    ReactDOM.render(
        <Facebook
            columnsAmount={columnsAmount}
            facebookUrl={facebookUrl}
        />, elem);
});


// WEBPACK FOOTER //
// ./Src/Components/Facebook/Facebook.jsx